import { HTMLAttributes, ImgHTMLAttributes, forwardRef } from 'react';
import './file-uploaded-preview.css';

interface FileUploadedPreviewProps extends HTMLAttributes<HTMLDivElement> {
  src: ImgHTMLAttributes<HTMLImageElement>['src'];
  alt: ImgHTMLAttributes<HTMLImageElement>['alt'];
}

const FileUploadedPreview = forwardRef<
  HTMLDivElement,
  FileUploadedPreviewProps
>(({ src, alt, className, ...props }, ref) => {
  return (
    <div
      className={`uploaded-file-preview ${className ?? ''}`}
      ref={ref}
      {...props}
    >
      <img src={src} alt={alt} className="ufp-image" />
    </div>
  );
});

export { FileUploadedPreview };
